export default "__VITE_ASSET__C$PvC3526yZztJqH$PdV1g__"